import { NumberInput } from "@mantine/core";
import { useCallback } from "react";

interface AddendumCptQuantityInputProps {
  codeId: string;
  label: string;
  value: number | string;
  error?: string;
  disabled: boolean;
  onChange: (codeId: string, value: number | string) => void;
  onBlur: () => void;
}

export function AddendumCptQuantityInput({
  codeId,
  label,
  value,
  error,
  disabled,
  onChange,
  onBlur,
}: AddendumCptQuantityInputProps) {
  const handleChange = useCallback(
    (nextValue: number | string) => onChange(codeId, nextValue),
    [codeId, onChange]
  );

  return (
    <NumberInput
      label={label}
      description="Enter the number of units for this CPT code."
      value={value}
      min={1}
      max={99}
      step={1}
      allowDecimal={false}
      allowNegative={false}
      clampBehavior="none"
      withAsterisk
      disabled={disabled}
      error={error}
      onChange={handleChange}
      onBlur={onBlur}
    />
  );
}
